var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabQna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1382 23.7764L24.7196 23.4857L24.7196 23.4857L24.1382 23.7764ZM23.3786 18.7265L22.7984 18.4335L23.3786 18.7265ZM23.2302 21.9604L22.6488 22.2511L23.2302 21.9604ZM2.85 14C2.85 20.158 7.84203 25.15 14 25.15V23.85C8.56 23.85 4.15 19.44 4.15 14H2.85ZM14 2.85C7.84203 2.85 2.85 7.84203 2.85 14H4.15C4.15 8.56 8.56 4.15 14 4.15V2.85ZM25.15 14C25.15 7.84203 20.158 2.85 14 2.85V4.15C19.44 4.15 23.85 8.56 23.85 14H25.15ZM23.9588 19.0195C24.721 17.5101 25.15 15.8042 25.15 14H23.85C23.85 15.5961 23.4709 17.1017 22.7984 18.4335L23.9588 19.0195ZM22.6488 22.2511L23.5568 24.0671L24.7196 23.4857L23.8116 21.6698L22.6488 22.2511ZM23.5568 24.0671C23.507 23.9673 23.5795 23.85 23.691 23.85V25.15C24.5459 25.15 25.1019 24.2503 24.7196 23.4857L23.5568 24.0671ZM23.691 23.85H14V25.15H23.691V23.85ZM22.7984 18.4335C22.2229 19.5732 22.0224 20.9983 22.6488 22.2511L23.8116 21.6698C23.4209 20.8883 23.5092 19.9099 23.9588 19.0195L22.7984 18.4335Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 11.2138C11.375 9.67798 12.8676 8.47072 14.5627 8.80647C15.5528 8.99934 16.3553 9.75655 16.5654 10.6852C16.8354 11.8925 16.1603 12.9854 15.1103 13.4498C14.4352 13.7498 14.0002 14.3713 14.0002 15.0713V16.625",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.125C14.3624 20.125 14.6562 19.8312 14.6562 19.4688C14.6562 19.1063 14.3624 18.8125 14 18.8125C13.6376 18.8125 13.3438 19.1063 13.3438 19.4688C13.3438 19.8312 13.6376 20.125 14 20.125Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabQna);
export default __webpack_public_path__ + "static/media/tab_qna.82bc4baeb145f16fa4eb927469b75f8c.svg";
export { ForwardRef as ReactComponent };